import React from 'react';

const RecipeDetails = ({ name, recipe }) => {
    return (
        <div className="recipe-details mt-3">
            <h5>🍽️ Recipe for: {name}</h5>

            <h6>Ingredients:</h6>
            <ul>
                {recipe.ingredients.map((item, i) => (
                    <li key={i}>{item}</li>
                ))}
            </ul>

            <h6>Steps:</h6>
            {recipe.steps.map((step, i) => (
                <p key={i}>
                    <strong>Step {i + 1}:</strong> {step}
                </p>
            ))}
        </div>
    );
};

export default RecipeDetails;
